module.exports = __webpack_public_path__ + "static/media/slide2_mobile.99b02c0c.webp";